import {useTheme} from 'styled-components';

import {mapObjIndexed} from 'ramda';

import {PhotoCheckerPartVariants} from '../types/PhotoCheckerPartVariants';
import {PhotoCheckerSilhouettePart} from '../types/PhotoCheckerSilhouettePart';
import {PhotoCheckerSilhouetteVariant} from '../types/PhotoCheckerSilhouetteVariant';
import {PhotoCheckerSilhouetteVariantColors} from '../types/PhotoCheckerSilhouetteVariantColors';
import {photoCheckerPhotoTypesByPart} from '../utils/photoCheckerPhotoTypesByPart';
import {PhotoCheckerSilhouetteSvg} from './PhotoCheckerSilhouetteSvg';

interface PhotoGuideSlotSilhouetteProps {
  part: PhotoCheckerSilhouettePart;
  isRequired: boolean;
}

const TRANSPARENT = 'transparent';

/** The PhotoChecker car silhouette with one part marked: the view an empty slot is waiting for. */
export function PhotoGuideSlotSilhouette(props: PhotoGuideSlotSilhouetteProps) {
  const theme = useTheme();

  // The overlay colours every part by variant; the unmarked parts get an invisible one.
  const hiddenPart = {
    circle: TRANSPARENT,
    gradient: TRANSPARENT,
    fill: theme.colors.palettes.white[10][100],
  };
  const colorsByVariant = {
    plain: hiddenPart,
    pass: hiddenPart,
    fail: hiddenPart,
    caution: {
      circle: theme.colors.palettes.orange[60][100],
      gradient: theme.colors.palettes.orange[60][100],
      fill: theme.colors.palettes.orange[30][100],
    },
    missing: {
      circle: theme.colors.palettes.neutral[100][100],
      gradient: theme.colors.palettes.neutral[100][100],
      fill: theme.colors.palettes.neutral[30][100],
    },
  } satisfies PhotoCheckerSilhouetteVariantColors;

  const markedVariant: PhotoCheckerSilhouetteVariant = props.isRequired ? 'caution' : 'missing';
  const partVariants: PhotoCheckerPartVariants = mapObjIndexed(
    (_photoTypes, part): PhotoCheckerSilhouetteVariant =>
      part === props.part ? markedVariant : 'plain',
    photoCheckerPhotoTypesByPart
  );

  return (
    <PhotoCheckerSilhouetteSvg
      colorsByVariant={colorsByVariant}
      hasEvaluation
      partVariants={partVariants}
    />
  );
}
